import React from 'react';
import { useTranslation } from "react-i18next";
import logo_icon from "../../assets/images/Simirity-icon-gold.png"

interface IProps {
}

/**
 * @param props
 * @returns void
 */
function DemoNotification(props:IProps) {

    const { t } = useTranslation();

    return(
        <div className={`notification-container info demo`} >
            <img src={logo_icon} className="logo-ball-picture" alt="demo"/>                
            <p className="notification-title">{t("Just browsing")}</p>
            <p className="notification-text">{t("You're exploring our demo account with Linda's family stories.")}</p>
            <p className="notification-text">{t("Some features are view-only.")}</p>
            <br />
            <p className="notification-text">{t("Join for the full experience.")}</p>
            <p>
                <a href="https://app.simirity.com/register" className="default-button">{t("Join for free")}</a>
            </p>

        </div>
    );
};

export default DemoNotification;